import { useEffect, useRef } from 'react';
import { supabase } from '@/lib/supabase';

/**
 * Calls seed edge functions once on app startup to ensure
 * the admin user exists in Supabase Auth.
 */
export default function SeedProvider({ children }: { children: React.ReactNode }) {
  const seeded = useRef(false);

  useEffect(() => {
    if (seeded.current) return;
    seeded.current = true;

    // Primary: setup-kaio (detailed error logging)
    supabase.functions.invoke('setup-kaio', {}).then(({ data, error }) => {
      if (error) {
        console.error('Setup Kaio - invoke error:', error.message, error);
      }
      if (data) {
        console.log('Setup Kaio - response:', JSON.stringify(data));
      }
    });

    // Backup: also try seed-users for default admin
    supabase.functions.invoke('seed-users', {}).then(({ data, error }) => {
      if (error) {
        console.warn('Seed users:', error.message);
      }
      if (data) {
        console.log('Seed users response:', JSON.stringify(data));
      }
    });
  }, []);

  return <>{children}</>;
}